import React from 'react';
import { useController } from 'react-hook-form';
import Select from './Select';

type SelectOptionType = React.ComponentProps<typeof Select>;

type ControlledSelectProps = Omit<
  Omit<SelectOptionType, 'onChange'>,
  'value'
> & {
  name: string;
  defaultValue?: string;
};

export const ControlledSelect: React.FC<ControlledSelectProps> = props => {
  const { name, defaultValue } = props;

  const {
    field: { onChange, value },
  } = useController({
    name,
  });

  const handleChange = (name: string, value: string) => {
    onChange(value);
  };

  return (
    <Select {...props} onChange={handleChange} value={value || defaultValue} />
  );
};
